import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SudokuComponent } from './games/sudoku.component';
import { QueensComponent } from './games/queens.component';
import { TangoComponent } from './games/tango.component';

import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';

export const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'minister-sudoku', component: SudokuComponent },
    { path: 'sudoku', redirectTo: 'minister-sudoku', pathMatch: 'full' },
    { path: 'queens', component: QueensComponent },
    { path: 'tango', component: TangoComponent },
    { path: 'privacy-policy', component: PrivacyPolicyComponent },
    { path: 'contact', loadComponent: () => import('./pages/contact/contact.component').then(m => m.ContactComponent) },
];

